// @ts-nocheck
import { createAsyncAction, createAction } from '../../../core/store/actionCreators';
import { FETCH_TOKEN, FETCH_CURRENT_USER, SET_AUTHENTICATED, SET_AUTHENTICATING } from './authActionTypes';
import AuthService from '../services/AuthService';

export const fetchToken = createAsyncAction(FETCH_TOKEN, async code => {
  const { data } = await AuthService.fetchToken(code);

  const expires = new Date();
  expires.setSeconds(expires.getSeconds() + data.expires_in - 300);

  localStorage.setItem('id_token', data.id_token);
  localStorage.setItem('access_token', data.access_token);
  localStorage.setItem('refresh_token', data.refresh_token);
  localStorage.setItem('expires', expires);
});

export const fetchCurrentUser = createAsyncAction(FETCH_CURRENT_USER, async () => {
  const { data } = await AuthService.fetchCurrentUser();
  return data;
});

export const setAuthenticated = createAction(SET_AUTHENTICATED);

export const setAuthenticating = createAction(SET_AUTHENTICATING);
